import { z } from 'zod';

export const billingPortalSessionCreateDto = z.object({
  returnUrl: z.string().url().describe('Return URL'),
});

export class BillingPortalSessionCreateDto {}
export interface BillingPortalSessionCreateDto extends z.input<
  typeof billingPortalSessionCreateDto
> {}
